<h2 mat-dialog-title>Configurações</h2>
<mat-dialog-content>
  <div class="settings-container" fxLayout="column" fxLayoutGap="16px">
    <div class="settings-card" (click)="openCarouselConfig()">
      <div class="card-icon-wrapper" style="background-color: #2196F3">
        <mat-icon>collections</mat-icon>
      </div>
      <div class="card-content">
        <h3>Configurar Carrossel</h3>
        <p>Gerencie as imagens do carrossel da página inicial</p>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fechar</button>
</mat-dialog-actions> 